import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import {
    useImageLoading,
    SkeletonLoading,
    useIdentificationContext,
    Variant,
} from '@fiverr-private/identification_core';
import { responsiveImg } from '../../../shared/styles/index.ve.css';
import { appTranslate } from '../../../i18n';
import withActivationImage from '../../../assets/with_activation.png';
import goWithActivationImage from '../../../assets/go_with_activation.png';

const getIllustrationImage = (variant: Variant) => {
    switch (variant) {
        case 'go':
            return goWithActivationImage;
        case 'default':
        default:
            return withActivationImage;
    }
};

export const WithActivationIllustration = () => {
    const { variant } = useIdentificationContext();
    const imageSrc = getIllustrationImage(variant);
    const { loading, onLoad } = useImageLoading(imageSrc);

    return (
        <SkeletonLoading loading={loading}>
            <Container position="relative" height="100%" width="100%">
                <img
                    onLoad={onLoad}
                    alt={appTranslate<string>('identification.banner.image_alt')}
                    className={responsiveImg}
                    src={imageSrc}
                />
            </Container>
        </SkeletonLoading>
    );
};
